var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleHung(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "single-hung",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.8,
    y: 59.5,
    width: 124.3,
    height: 4.7,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.8,
    y: 117.2,
    width: 124.3,
    height: 4.7,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.7,152.1l-8.8-15.2l-8.8,15.2h3.7v11.2H105v-11.2H108.7z M103.8,162.1H96v-10v-1.2h-1.2h-1.7l6.8-11.7l6.8,11.7H105 h-1.2v1.2V162.1z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.7,152.7l-8.8-15.2l-8.8,15.2h3.7v11.2H105v-11.2H108.7z M103.8,162.7H96v-10v-1.2h-1.2h-1.7l6.8-11.7l6.8,11.7H105 h-1.2v1.2V162.7z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166,198.9H34c-6.3,0-11.4-5.1-11.4-11.4v-175c0-6.3,5.1-11.4,11.4-11.4h132c6.3,0,11.4,5.1,11.4,11.4v175 C177.4,193.8,172.3,198.9,166,198.9z M34,5.8c-3.7,0-6.7,3-6.7,6.7v175c0,3.7,3,6.7,6.7,6.7h132c3.7,0,6.7-3,6.7-6.7v-175 c0-3.7-3-6.7-6.7-6.7H34z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.6,187.4c-0.1,0-0.1,0-0.2,0l-124.8,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-1.3-0.1-2.3-1.2-2.2-2.5l0-169.3 c0-0.1,0-0.3,0-0.4c0.1-1.2,1.1-2.2,2.3-2.2c0.1,0,0.1,0,0.2,0l124.8,0c1.4,0,2.5,1.1,2.5,2.5v169.3c0,0.1,0,0.3,0,0.4 C164.8,186.4,163.8,187.4,162.6,187.4C162.6,187.4,162.6,187.4,162.6,187.4z M40.1,182.3h119.8v-74.1H40.1V182.3z M102.3,103.3 h57.6V18.1h-57.6V103.3z M40.1,103.3h57.2V18.1H40.1V103.3z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleHung);
export default __webpack_public_path__ + "static/media/single-hung.9b5c0f0fd93879eb520bb6182f86d65f.svg";
export { ForwardRef as ReactComponent };